export const Taskstatus = [
  { value: "Open", name: "Open" },
  { value: "Held", name: "Held" },
  { value: "Cancelled", name: "Cancelled" },
  { value: "Complete", name: "Complete" },
];
export const TaskPriority = [
  { value: 0, name: "High" },
  { value: 1, name: "Medium" },
  { value: 2, name: "Low" },
];

export const TaskCategory = [
  { value: "NORMAL", name: "Normal" },
  { value: "PRESCRIPTION", name: "Prescription" },
  { value: "DOCUMENT_REVIEW", name: "Document Review" },
];

export const Documentstatus = [
  { value: "NEW", name: "New" },
  { value: "IN_REVIEW", name: "In review" },
  { value: "REVIEWED", name: "Reviewed" },
  { value: "REFERRED", name: "Refferred" },
];
export const Documenttype = [
  { value: "Consultation result", name: "Consultation result" },
  { value: "Doctors letter", name: "Doctors letter" },
  { value: "Patient letter", name: "Patient letter" },
  { value: "Other", name: "Other" },
];
